module.exports = "/_next/static/images/Iso27001@2x-80061c433836fded9fb70f20ef5bbe71.png";